import { LookupListModel } from '../../../lookup/lookup-list';
import { ElasticsearchFieldModel } from '../../../elasticsearch/elasticsearch-field';
import lookupFilterParser from '../../../osd/filters/parsers/lookup-filter-parser';
import { ElasticsearchEnhancedFilterModel } from '../../../elasticsearch/elasticsearch-filter';
import { BaseExploreFilterParser } from './base';
/**
 * Elastic to ElasticsearchFilterModel 'LOOKUP' filter parser
 */
export class ExploreFilterLookupFilterParser extends BaseExploreFilterParser {
    constructor() {
        super(lookupFilterParser);
    }
    getFilter(elasticFilter, negate) {
        const metadata = this.getMetadata(elasticFilter, negate);
        if (!metadata)
            return null;
        const filter = new ElasticsearchEnhancedFilterModel();
        const lookupTable = new LookupListModel();
        lookupTable.id = metadata.id;
        lookupTable.name = metadata.name;
        filter.type = 'LOOKUP';
        filter.value = lookupTable;
        filter.negate = metadata.negate;
        filter.field = new ElasticsearchFieldModel();
        filter.field.name = metadata.key ?? '';
        return filter;
    }
    getElasticFilter(filter) {
        if (filter.type !== 'LOOKUP')
            return null;
        return {
            [this.baseFilterParser.elasticKey]: {
                id: filter.value.id,
                name: filter.value.name,
                field: filter.field?.name,
            },
        };
    }
}
//# sourceMappingURL=lookup.js.map